import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal, { ModalProps } from '@mui/material/Modal';
import { FC } from 'react';

export const BaseModal: FC<ModalProps> = ({ children, ...props }) => {
  return (
    <Modal
      {...props}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 250,
      }}
    >
      <Fade in={props.open}>{children}</Fade>
    </Modal>
  );
};
